import { getSkillById } from '../gphSkillRegistry';
import {
  validateMiAnalysisSlots,
  buildMissingMiAnalysisSlotsMessage,
  buildInvalidMiAnalysisSlotsMessage
} from '../validation/miAnalysisSlotValidator';
import {
  renderMiAnalysisStarted,
  renderMiAnalysisHumanError
} from '../renderers/miAnalysisResultRenderer';

export const prepareMiAnalysisSkill = ({
  slots = {},
  host = {}
} = {}) => {
  const skill = getSkillById('mi_analysis');
  const validation = validateMiAnalysisSlots(slots, host);

  if (validation.invalidSlots.length > 0) {
    return {
      status: 'invalid',
      skill,
      slots: validation.normalizedSlots,
      missingSlots: validation.missingSlots,
      invalidSlots: validation.invalidSlots,
      message: buildInvalidMiAnalysisSlotsMessage(validation.invalidSlots)
    };
  }

  if (validation.missingSlots.length > 0) {
    return {
      status: 'needs_slots',
      skill,
      slots: validation.normalizedSlots,
      missingSlots: validation.missingSlots,
      invalidSlots: [],
      message: buildMissingMiAnalysisSlotsMessage(validation.missingSlots)
    };
  }

  return {
    status: 'ready',
    skill,
    slots: validation.normalizedSlots,
    missingSlots: [],
    invalidSlots: [],
    message: null
  };
};

export const executeMiAnalysisSkill = async ({
  slots = {},
  host = {},
  language = 'pt-BR'
} = {}) => {
  const prepared = prepareMiAnalysisSkill({ slots, host });

  if (prepared.status !== 'ready') {
    return prepared;
  }

  if (typeof host.startMiAnalysis !== 'function') {
    return {
      ...prepared,
      status: 'error',
      message: 'Nao consegui abrir o envio da Mi Analise agora.'
    };
  }

  try {
    const file = prepared.slots.video;
    const context = {
      game_id: prepared.slots.game || host.canonicalGame || 'pubg_mobile',
      analysisGoal: prepared.slots.analysisGoal,
      validationGoal: prepared.slots.analysisGoal,
      notes: prepared.slots.notes || null,
      source: 'mi_skill_orchestrator',
      language
    };

    await host.startMiAnalysis(file, context);

    const result = {
      kind: 'analysis_started',
      fileName: file?.name || file?.fileName || 'video',
      analysisGoal: prepared.slots.analysisGoal,
      game: context.game_id
    };

    return {
      ...prepared,
      status: 'success',
      result,
      renderedText: renderMiAnalysisStarted(result)
    };
  } catch (error) {
    return {
      ...prepared,
      status: 'blocked_or_error',
      backendStatus: error.status || null,
      message: renderMiAnalysisHumanError({
        status: error.status,
        message: error.message
      })
    };
  }
};

export default executeMiAnalysisSkill;
